<template>
  <div class="app-container">
    <div class="full">
      <van-nav-bar title="我的" />


      <div class="info">
        <div class="avator" @click="getInfo">
          <div class="avator-img"></div>
          <div class="information">
            <p class="name top">{{ userInfo.yzxm || '' }}</p>
            <p class="name bottom">
              <span v-if="eyes == 'eye-o'"> {{ userInfo.zjhm || 0 }}</span>
              <span v-else> {{ userInfo.zjhm | IdCard }}</span> &nbsp;&nbsp;
              <van-icon :name="eyes" @click="handlerClick" />
            </p>
          </div>
        </div>
        <div class="item" @click="editHouse(userInfo.yzfwVo)">
          <div class="left">
            <img class="icon" src="../../assets/img/ico_house.png" alt="" />
            <p class="house">我的房屋</p>
          </div>
          <div class="right">
            <span class="num" style="color: #6b6a6a">
              数量：{{ userInfo.yzfwVo.length || 0 }} &nbsp;
              <van-icon name="arrow" />
            </span>
          </div>
        </div>
        <div class="item" @click="handlerPhone">
          <div class="left">
            <img class="icon" src="../../assets/img/ico_phone.png" alt="" />
            <p class="house">手机号</p>
          </div>
          <div class="right">
            <span class="num" style="color: #6b6a6a">
              {{ userInfo.lxdh | tel }} &nbsp;
              <!-- <van-icon /> -->
            </span>
          </div>
        </div>
      </div>
      <div class="footer" ref="footer" @click="handleCancel">
        <p class="footer-btn">解除绑定</p>
        <p class="cancel">解绑后须重新认证登录</p>
      </div>
    </div>
    <!-- 提示框 -->
    <van-dialog v-model="show" width="240px" height="160px" :before-close="beforeClose" show-cancel-button>
      <div class="card">
        <div class="icon"></div>
        <p class="warn">解除绑定后，须重新认证登录。</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from '@/api/login.js'
export default {

  data() {
    return {
      eyes: "closed-eye",
      show: false,
      loading: true,
      openId: sessionStorage.getItem('openId'),
      userInfo: {
        yzfwVo: []
      }
    };
  },
  mounted() {
    this.loading = false
    this.userInfo = JSON.parse(sessionStorage.getItem('userinfo'))
    this.getIphone()
  },
  filters: {
    tel(val) {
      let str = val + ''
      return str.substr(0, 3) + "****" + str.substr(7)
    },
    IdCard(val) {
      let str = val + ''
      return str.substr(0, 3) + "***********" + str.substr(14)
    }
  },
  methods: {
    getUserinfo() {
      let openId = sessionStorage.getItem('openId')
      api.info({ openId: openId }).then(res => {
        if (res.data.code == 200) {
          this.userInfo = res.data.data
        } else {
          this.$toast.fail({
            message: '获取信息失败',
          })
        }
      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },
    getIphone() {
      let iPhonex_xs = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
      let iPhonexsmax = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
      let iPhonexr = window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896
      let isIPhone12 =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 390 &&
        window.screen.height === 844;
      let isIPhone12ProMax =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 428 &&
        window.screen.height === 926;

      let isIPhone12mini =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 360 &&
        window.screen.height === 780;


      if (iPhonex_xs || iPhonexsmax || iPhonexr || isIPhone12ProMax || isIPhone12 || isIPhone12mini) {
        this.$refs.footer.style.bottom = '18%';
      }

    },
    /**
     * 完善资料
     */
    getInfo() {
      // this.$router.push('/user')
    },
    onClickLeft() {
      // window.history.go(-1)
      location.href = '/house'
    },
    /**
     * 关闭/打开眼睛
     */
    handlerClick(name) {
      let temp = this.eyes
      if (temp == 'closed-eye') {
        this.eyes = 'eye-o'
      } else if (temp == 'eye-o') {
        this.eyes = 'closed-eye'
      }
    },
    handlerPhone() {
      this.$toast.fail({
        message: '暂未开发',
      })
    },
    /**
     * 解除提示
     */
    handleCancel() {
      this.show = true

    },

    beforeClose(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === 'confirm') { // 确认
        let openId = sessionStorage.getItem("openId");
        api.delete(openId).then(res => {
          if (res.data.code == 200) {
            this.$toast.success({
              message: '解除成功',
            })

            sessionStorage.removeItem('wyqy')
            sessionStorage.removeItem('fwId')
            location.href = '/register'
            // this.$router.push('/register')
          } else {
            this.$toast.fail({
              message: '解除失败',
            })
          }

        }).catch(err => {
          this.$toast.fail({
            message: '解除失败',
          })
        })
        done();
        // 关闭提示框
      } else if (action === 'cancel') { // 取消
        done(); // 关闭提示框
      }
    },
    editHouse(val) {
      location.href = '/house' + '?list=' + val
      // this.$router.push({ path: '/house', query: { list: val } })
    }
  },
  created() { },
  watch: {},
};
</script>

<style lang="less" scoped>
.app-container {
  height: 100vh;
  background: #f4f7f9;
}

.van-nav-bar {
  background-color: #f1f1f1;
}

.info {
  position: relative;
  width: 100%;
  min-height: 360px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 16px;
  background-color: #fff;
  background: url(./../../assets/img/bg1.png) no-repeat;
  background-position: -4px 15px;

  .avator {
    display: flex;
    width: 100%;
    height: 50px;
    margin-top: 20px;
    padding-left: 10px;

    .avator-img {
      // flex: 1;
      width: 50px;
      height: 50px;
      background: url("../../assets/img/photo.png") no-repeat;
      background-size: 100% 100%;
    }

    .information {
      padding-left: 10px;
      flex: 2;

      .name {
        width: 100%;
        font-size: 18px;
        margin: 0;
      }

      .top {
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222120;
        line-height: 25px;
      }

      .bottom {
        // width: 60%;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 25px;
      }
    }
  }

  .item {
    display: flex;
    width: 100%;
    height: 22px;
    margin-top: 30px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .left {
      flex: 2;

      .house {
        display: inline-block;
        width: 75%;
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #222120;
        margin: 0 5px;
        vertical-align: middle;

        line-height: 22px;
      }

      .right {
        flex: 1;
        color: #6b6a6a;

        .num {
          display: inline-block;
          width: 25%;
        }
      }
    }

    .icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;



    }
  }
}

.footer {
  position: absolute;
  bottom: 10%;
  width: 100%;
  height: 76px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #222120;
  line-height: 46px;
  padding: 16px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;

  .footer-btn {
    height: 46px;
    text-align: center;

    background: #ffffff;
    border: 1px solid #e9e9e9;
    margin: 0;
  }

  .cancel {
    width: 100%;
    height: 17px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: #999998;
    text-align: center;
    line-height: 14px;
  }
}

.card {
  width: 100%;
  height: 150px;
  padding: 27px 22px;
  background: #ffffff;
  text-align: center;

  border-radius: 8px 8px 8px 8px;
  opacity: 1;

  .icon {
    width: 47px;
    height: 47px;
    margin: 0px auto;
    background: url("../../assets/img/ico_warn.png") no-repeat;
    background-size: 100% 100%;
  }

  .warn {
    width: 100%;
    height: 20px;
    text-align: center;

    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 16px;
  }
}

.primary {
  width: 96px;
  height: 42px;
  background: #ff6c1a;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  width: 32px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 19px;
}

/deep/.van-button-default {
  margin-top: 20px;
  background-color: #ff6c1a !important;
}
</style>
